"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _1 = require("./");
/**
 * *******************************
 * Functions
 * *******************************
 */
/**
 * Checks to see if the value is null or udefined
 *
 * @export
 * @param {T} value Value to check
 * @returns {boolean}
 */
function isNullOrUndefined(value) {
    return value === null || isUndefined(value);
}
exports.isNullOrUndefined = isNullOrUndefined;
/**
 * Will validate the passed parameter against isNullOrUndefined, isObjectAndEmpty, isArrayAndEmpty, isStringAndEmpty
 *
 * @export
 * @param {any} value
 * @returns {boolean}
 */
function isNullOrEmpty(value) {
    return isNullOrUndefined(value) || _1.isStringAndEmpty(value) || _1.isArrayAndEmpty(value) || _1.isObjectAndEmpty(value);
}
exports.isNullOrEmpty = isNullOrEmpty;
/**
 * Will validate if the given value is undefined or not
 *
 * @export
 * @param {T} value
 * @returns {T}
 */
function isUndefined(value) {
    return value === void 0;
}
exports.isUndefined = isUndefined;
/**
 * Returns copy of an object
 *
 * @export
 * @param {T} value
 * @returns {T}
 */
function deepCopy(value) {
    if (!isUndefined(value)) {
        var response = JSON.parse(JSON.stringify(value));
        return response;
    }
    return null;
}
exports.deepCopy = deepCopy;
//# sourceMappingURL=any.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@kurtosys/ksys_utils/dist/any.js
// module id = 1439
// module chunks = 1